import React from 'react';
import mainBG from '../../../assets/EinführungMainBG.png';
import ellipseBG from '../../../assets/EllipseBG.png';
import { useTranslation } from "react-i18next";

const PolicyForm = ({ nextClick, backClick, formik, setRenderForm, index, setIndex }) => {
    const { t } = useTranslation();
    const isSmallScreen = window.innerHeight <= 600;

    return (
        <div style={{ background: `url(${mainBG})` }} className="h-screen !bg-cover !bg-no-repeat !bg-center flex flex-col justify-between">
            <div></div>
            <div style={{ background: `url(${ellipseBG})` }} className="min-h-[75vh] !bg-cover !bg-no-repeat !bg-top relative">
                <div className="relative h-full mx-auto w-full max-w-[36rem] text-center pb-4 px-6 sm:px-0">
                    <div className="h-full">
                        <div className="flex flex-col justify-between h-full pt-20 items-center">
                            {/* Policy Content */}
                            <div className="w-full max-w-[32rem] sm:max-w-[36rem]">
                                <div className="text-left">
                                    <p className="text-white font-semibold text-xl text-center">{t(`s-policy-title`)}</p>

                                    {/* Radio Buttons for Medication */}
                                    <div className="flex flex-col gap-3 mt-4">
                                        {/* Yes Option with Input Field */}
                                        <div className="flex items-center gap-3">
                                            <input
                                                type="radio"
                                                className="custom-radio my-3"
                                                id="ja"
                                                name="medication"
                                                value="Yes"
                                                checked={formik.values.medication === 'Yes'}
                                                onChange={formik.handleChange}
                                            />
                                            <label htmlFor="ja" className="text-[#F9DCD4] font-normal">{t(`yes`)}</label>
                                            {formik.values.medication === 'Yes' && (
                                                <input
                                                    type="text"
                                                    name="details"
                                                    placeholder={t(`s-policy-place`)}
                                                    className="simurg_input !w-auto"
                                                    value={formik.values.details}
                                                    onChange={formik.handleChange}
                                                />
                                            )}
                                        </div>

                                        {formik.errors.details && formik.values.medication === 'Yes' && (
                                            <div className="text-red-500 text-sm">{formik.errors.details}</div>
                                        )}

                                        {/* No Option */}
                                        <div className="flex items-center gap-3">
                                            <input
                                                type="radio"
                                                className="custom-radio my-3"
                                                id="nein"
                                                name="medication"
                                                value="No"
                                                checked={formik.values.medication === 'No'}
                                                onChange={formik.handleChange}
                                            />
                                            <label htmlFor="nein" className="text-[#F9DCD4] font-normal">{t(`no`)}</label>
                                        </div>

                                        {formik.errors.medication && (
                                            <div className="text-red-500 text-sm">{formik.errors.medication}</div>
                                        )}
                                    </div>

                                    {/* Policy Agreement Checkbox */}
                                    <div className="flex items-start gap-3 mt-4">
                                        <input
                                            type="checkbox"
                                            id="policy"
                                            name="agreement"
                                            checked={formik.values.agreement}
                                            onChange={formik.handleChange}
                                            className="radio-circle !w-full !max-w-[20px]"
                                        />
                                        <label htmlFor="policy" className="text-white text-left text-base font-semibold">
                                            {t(`s-policy-des`)}
                                            <br />
                                            <a target="_blank" rel="noopener noreferrer" className="underline" href={t(`drive_link_3`)}>
                                                {t(`s-policy-link`)}
                                            </a>
                                            {t(`s-policy-des2`)}
                                        </label>
                                    </div>

                                    {formik.errors.agreement && (
                                        <div className="text-red-500 text-sm mt-1">{formik.errors.agreement}</div>
                                    )}
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className={`w-full max-w-[32rem] sm:max-w-[36rem] flex gap-6 flex-col-reverse sm:flex-row ${isSmallScreen ? 'pt-2' : 'pt-6'}`}>
                                <button className="w-full button_primary" onClick={() => { setRenderForm(index ? index == 10 ? 8 : index : 9); setIndex(null); }}>
                                    {t(`s-2-btn1`)}
                                </button>
                                <button className="w-full button_secodry" onClick={nextClick}>
                                    {t(`s-2-btn2`)}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PolicyForm;
